// extracted by mini-css-extract-plugin
export default {"container":"privacyPolicyEn_container__Qd97G","header":"privacyPolicyEn_header__FlDYr","updatedDate":"privacyPolicyEn_updatedDate__0Zd-7","list":"privacyPolicyEn_list__Y8EY-"};